import { useAutoneTranslation } from '@autone/translations';
import { type FC } from 'react';

import {
  Button,
  Sheet,
  SheetBody,
  SheetClose,
  SheetContent,
  SheetDivider,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '../../../../atoms';
import {
  type DatasetsDataFreshnessStatus,
  type GeneratedDataFreshnessDataset,
  type UploadedDataFreshnessDataset,
} from '../DataFreshnessWidget.types';

import { DataFreshnessSidesheetContent } from './DataFreshnessSidesheetContent';

interface SeeDetailsButtonProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  uploadedDatasets: UploadedDataFreshnessDataset[];
  generatedDatasets: GeneratedDataFreshnessDataset[];
  dataFreshnessStatus: DatasetsDataFreshnessStatus;
}

export const DataFreshnessDetailsSheet: FC<SeeDetailsButtonProps> = ({
  isOpen,
  setIsOpen,
  ...props
}) => {
  const { common } = useAutoneTranslation();

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent
        side="right"
        className="sm:max-w-[600px]"
        id="data-freshness-details-sheet"
      >
        <SheetHeader>
          <SheetTitle>
            {common('data-age.global-widget.details-sidesheet.title')}
          </SheetTitle>
        </SheetHeader>
        <SheetDivider />
        <SheetBody>
          <DataFreshnessSidesheetContent {...props} />
        </SheetBody>
        <SheetFooter>
          <SheetClose asChild>
            <Button
              variant="ghost"
              aria-label="Close"
              id="close-button"
              className="w-fit"
            >
              {common('close')}
            </Button>
          </SheetClose>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};
